import { Trans } from "@lingui/react/macro";
import { Button } from "@rakazo/ui-web";

/**
 * What an employee sees where a card would ask them to set something up (a secret, an app, an MCP
 * server). Only IT does that in stage 1, so the card says so; a secret request can still be turned down.
 */
export function AskItToSetUp({
  canDismiss = false,
  disabled = false,
  onDismiss,
}: {
  canDismiss?: boolean;
  disabled?: boolean;
  onDismiss?: () => void | Promise<void>;
}) {
  return (
    <div className="mt-3.5 flex flex-col items-start gap-2" data-testid="ask-it-to-set-up">
      <p className="text-[13.5px] text-muted-foreground">
        <Trans>Ask IT to set this up.</Trans>
      </p>
      {canDismiss && onDismiss ? (
        <Button
          type="button"
          variant="outline"
          disabled={disabled}
          onClick={() => void onDismiss()}
        >
          <Trans>Dismiss</Trans>
        </Button>
      ) : null}
    </div>
  );
}
